export const ALLOWED_MAX_SIZE_IN_BYTES = 2_147_483_648; // 2 GB

export const isUploadFileSizeExceeded = (file: File): boolean =>
  file.size > ALLOWED_MAX_SIZE_IN_BYTES;
